import { useLocation, useNavigate } from "react-router-dom";
import SeoHead from "@/components/feature/SeoHead";
import { useTheme } from "@/theme";
import { site } from "@/content";

export default function NotFound() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isDark } = useTheme();

  const homeHref = "/";

  return (
    <>
      <SeoHead
        title={site.seo.notFound.title}
        description={site.seo.notFound.description}
        keywords={site.seo.notFound.keywords}
        canonicalPath="/"
      />
    <div
      className={`relative flex flex-col items-center justify-center min-h-screen text-center px-4 overflow-hidden transition-colors duration-500 ${
        isDark ? "bg-[#0C0C0E]" : "bg-[#FAFAF8]"
      }`}
    >
      {/* Logo */}
      <a
        href={homeHref}
        className={`absolute top-6 left-1/2 -translate-x-1/2 flex items-center gap-2 cursor-pointer group z-20 ${
          isDark ? "" : ""
        }`}
      >
        <div
          className={`w-7 h-7 flex items-center justify-center rounded-md transition-all duration-300 group-hover:scale-110 group-hover:rotate-6 ${
            isDark
              ? "bg-amber-500 group-hover:bg-amber-400"
              : "bg-amber-600 group-hover:bg-amber-500"
          }`}
        >
          <i
            className={`ri-flashlight-line text-sm transition-transform duration-300 group-hover:scale-110 ${
              isDark ? "text-[#0C0C0E]" : "text-white"
            }`}
          ></i>
        </div>
        <span
          className={`text-lg font-bold tracking-tight transition-colors duration-300 ${
            isDark
              ? "text-white group-hover:text-amber-300"
              : "text-gray-900 group-hover:text-amber-700"
          }`}
        >
          Быстренко
          <span
            className={`transition-colors duration-300 ${
              isDark
                ? "text-amber-700 group-hover:text-amber-300"
                : "text-amber-600 group-hover:text-amber-700"
            }`}
          >
            .ру
          </span>
        </span>
      </a>

      {/* Ambient blobs */}
      {isDark ? (
        <>
          <div className="absolute top-[-10%] left-[-10%] w-[500px] h-[500px] rounded-full bg-orange-500/10 blur-[140px] pointer-events-none" />
          <div className="absolute bottom-[-10%] right-[-10%] w-[400px] h-[400px] rounded-full bg-cyan-500/10 blur-[120px] pointer-events-none" />
          <div className="absolute top-[40%] right-[20%] w-[300px] h-[300px] rounded-full bg-violet-500/10 blur-[100px] pointer-events-none" />
        </>
      ) : (
        <>
          <div className="absolute top-[-10%] left-[-10%] w-[500px] h-[500px] rounded-full bg-orange-200/40 blur-[140px] pointer-events-none" />
          <div className="absolute bottom-[-10%] right-[-10%] w-[400px] h-[400px] rounded-full bg-cyan-200/30 blur-[120px] pointer-events-none" />
        </>
      )}

      {/* Giant 404 */}
      <h1
        className={`text-[8rem] md:text-[14rem] font-black select-none pointer-events-none leading-none transition-colors duration-500 ${
          isDark
            ? "text-transparent bg-gradient-to-br from-slate-800 to-slate-900 bg-clip-text"
            : "text-gray-100"
        }`}
      >
        404
      </h1>

      <div className="relative z-10 -mt-8 md:-mt-16">
        <div
          className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-semibold tracking-widest uppercase mb-6 ${
            isDark
              ? "bg-slate-800/60 border border-slate-700/50 text-slate-500"
              : "bg-gray-100 text-gray-500"
          }`}
        >
          <span className={`w-2 h-2 rounded-full ${isDark ? "bg-orange-500" : "bg-orange-400"}`} />
          Страница не найдена
        </div>

        <h2
          className={`text-xl md:text-2xl font-semibold mb-3 transition-colors duration-500 ${
            isDark ? "text-white" : "text-gray-900"
          }`}
        >
          Такой страницы не существует
        </h2>
        <p
          className={`text-sm md:text-base font-mono mb-8 transition-colors duration-500 ${
            isDark ? "text-slate-500" : "text-gray-400"
          }`}
        >
          {location.pathname}
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href={homeHref}
            className={`px-8 py-3.5 rounded-2xl font-semibold text-sm transition-all cursor-pointer whitespace-nowrap ${
              isDark
                ? "bg-white text-gray-900 hover:bg-gray-100"
                : "bg-gray-900 text-white hover:bg-gray-800"
            }`}
          >
            На главную
          </a>
          <button
            onClick={() => navigate(-1)}
            className={`px-8 py-3.5 rounded-2xl font-semibold text-sm transition-all cursor-pointer whitespace-nowrap ${
              isDark
                ? "border border-slate-700 text-slate-500 hover:border-slate-500 hover:bg-slate-800/50"
                : "border border-gray-200 text-gray-600 hover:border-gray-400 hover:bg-gray-50"
            }`}
          >
            Вернуться назад
          </button>
        </div>
      </div>
    </div>
    </>
  );
}